import {
  IApiResponse,
  IAuditTrail,
  IBay4S,
  IBay4SDetail,
  IDeliveryBarcodeHistory,
  IDeliveryBarcodeHistoryDetail,
  IFinishedProductPallet,
  IGetAllLocationsReportRequest,
  IGetAuditTrailRequest,
  IGetBay4SDetail,
  IGetDeliveryBarcodeHistoryDetailRequest,
  IGetDeliveryBarcodeHistoryRequest,
  IGetSlowMovingStockRequest,
  IGetTrackingBarcodeRequest,
  IImportBay4sRequest,
  ILocationReport,
  IPaginateApiResponse,
  IPaginationRequest,
  IPalletWait,
  IQuantityMoving,
  IReturnRequest,
  ISlowMoving,
  ITrackingBarcode,
  ITrackingBarcodeInfo,
  IZoneDetailReport,
  IZoneReport,
} from "model";
import { IForkliftPerformance } from "model/ForkLiftPerformance";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

export const prefix = PREFIX.report;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_GET_AUDIT_TRAIL = getUrl("audit-trails");
const URL_GET_ALL_ZONES_REPORT = getUrl("warehouse-detail/zone-list");
const URL_GET_ALL_LOCATIONS_REPORT = getUrl("warehouse-detail/location-list");
const URL_GET_ALL_EMPTY_LOCATIONS_REPORT = getUrl(
  "warehouse-detail/empty-location"
);
const URL_GET_ALL_PRODUCT_LOT_REPORT = getUrl(
  "warehouse-detail/report-by-product-lot"
);
const URL_GET_ZONE_DETAIL_REPORT = getUrl("warehouse-detail/zone-detail");
const URL_GET_FINISHED_PRODUCT_PALLET_WAIT_TO_WAREHOUSE = getUrl(
  "warehouse-detail/finished-product-pallet-wait-to-warehouse"
);
const URL_GET_PACKING_DETAIL_BY_QR_CODE = getUrl(
  "warehouse-detail/packaging-log-by-qr-code"
);
const URL_GET_QUANTITY_MOVE_REPORT = getUrl(
  "quantity-move-report/quantity-move-list"
);
const URL_GET_SLOW_MOVING_STOCK = getUrl(
  "slow-moving-stock-report/slow-moving-stock"
);
const URL_GET_FINISHED_PRODUCT_PALLETS = getUrl("finished-product-pallets");
const URL_GET_FORKLIFT_PERFORMANCE = getUrl(
  "fork-lift-performance-report/fork-lift-move"
);
const URL_GET_DELIVERY_BARCODE_HISTORY = getUrl(
  "delivery-barcode-history/get-list"
);
const URL_GET__DELIVERY_BARCODE_HISTORY_DETAIL = getUrl(
  "delivery-barcode-history/get-detail"
);
const URL_GET_BAY_4S = getUrl("bay4s/get-list");
const URL_GET_BAY_4S_DETAIL = getUrl("bay4s/get-detail");
const URL_GET_TRACKING_BARCODE = getUrl("barcode-tracking/get-tracking");
const URL_GET_TRACKING_BARCODE_INFO = getUrl("barcode-tracking/get-info");
const URL_IMPORT_BAY_4S = getUrl("import-bay4s-data");
const URL_GET_RETURN_REPORT = getUrl("return-product-report");
const URL_GET_CYCLE_COUNT_QA_COLLECT = getUrl("cycle-count-qa-collect-report");

class ReportApiService extends BaseApiService {
  public getAuditTrail = (request: IGetAuditTrailRequest) =>
    this.get<IApiResponse<IAuditTrail[]>>(URL_GET_AUDIT_TRAIL, {
      params: request,
    });
  public getAllZonesReport = () =>
    this.get<IApiResponse<IZoneReport[]>>(URL_GET_ALL_ZONES_REPORT);
  public getZoneDetailReport = () =>
    this.get<IApiResponse<IZoneDetailReport[]>>(URL_GET_ZONE_DETAIL_REPORT);
  public getAllLocationsReport = (request: IGetAllLocationsReportRequest) =>
    this.get<IApiResponse<ILocationReport[]>>(URL_GET_ALL_LOCATIONS_REPORT, {
      params: request,
    });
  public getAllProductLotReport = (request: IGetAllLocationsReportRequest) =>
    this.get<IApiResponse<any[]>>(URL_GET_ALL_PRODUCT_LOT_REPORT, {
      params: request,
    });
  public getEmptyLocationsReport = (request: IGetAllLocationsReportRequest) =>
    this.get<IApiResponse<ILocationReport[]>>(
      URL_GET_ALL_EMPTY_LOCATIONS_REPORT,
      {
        params: request,
      }
    );
  public getFinishedProductPalletWaitToWarehouse = (
    request: IPaginationRequest
  ) =>
    this.get<IPaginateApiResponse<IPalletWait[]>>(
      URL_GET_FINISHED_PRODUCT_PALLET_WAIT_TO_WAREHOUSE,
      {
        params: request,
      }
    );
  public getPackingLogByQRCode = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IPalletWait[]>>(
      URL_GET_PACKING_DETAIL_BY_QR_CODE,
      {
        params: request,
      }
    );

  public getQuantityMoveReport = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IQuantityMoving[]>>(
      URL_GET_QUANTITY_MOVE_REPORT,
      {
        params: request,
      }
    );

  public getFinishedProductPallets = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IFinishedProductPallet[]>>(
      URL_GET_FINISHED_PRODUCT_PALLETS,
      {
        params: request,
        timeout: 0,
      }
    );
  public getForkliftPerformance = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IForkliftPerformance[]>>(
      URL_GET_FORKLIFT_PERFORMANCE,
      {
        params: request,
      }
    );
  public getSlowMovingStock = (request: IGetSlowMovingStockRequest) =>
    this.get<IPaginateApiResponse<ISlowMoving[]>>(URL_GET_SLOW_MOVING_STOCK, {
      params: request,
    });

  public getDeliveryBarcodeHistoryList = (
    request: IGetDeliveryBarcodeHistoryRequest
  ) =>
    this.get<IPaginateApiResponse<IDeliveryBarcodeHistory[]>>(
      URL_GET_DELIVERY_BARCODE_HISTORY,
      {
        params: request,
      }
    );
  public getDeliveryBarcodeHistoryDetail = (
    request: IGetDeliveryBarcodeHistoryDetailRequest
  ) =>
    this.get<IPaginateApiResponse<IDeliveryBarcodeHistoryDetail[]>>(
      URL_GET__DELIVERY_BARCODE_HISTORY_DETAIL,
      {
        params: request,
      }
    );

  public getBay4SList = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IBay4S[]>>(URL_GET_BAY_4S, {
      params: request,
    });
  public getBay4SDetail = (request: IGetBay4SDetail) =>
    this.get<IPaginateApiResponse<IBay4SDetail[]>>(URL_GET_BAY_4S_DETAIL, {
      params: request,
    });

  public getTrackingBarcode = (request: IGetTrackingBarcodeRequest) =>
    this.get<IPaginateApiResponse<ITrackingBarcode[]>>(
      URL_GET_TRACKING_BARCODE,
      {
        params: request,
      }
    );
  public getTrackingBarcodeInfo = (request: IGetTrackingBarcodeRequest) =>
    this.get<IApiResponse<ITrackingBarcodeInfo[]>>(
      URL_GET_TRACKING_BARCODE_INFO,
      {
        params: request,
      }
    );
  public importBay4s = (request: IImportBay4sRequest) =>
    this.postForm<IImportBay4sRequest, any>(URL_IMPORT_BAY_4S, request);

  public getReturnReport = (request: IReturnRequest) =>
    this.get<any>(URL_GET_RETURN_REPORT, { params: request });
  public getCycleCOuntQACollect = (request: IPaginationRequest) =>
    this.get<any>(URL_GET_CYCLE_COUNT_QA_COLLECT, { params: request });
}

export default new ReportApiService();
